import * as React from 'react'
import type { Color } from '../../../theme/colors'
import colors from '../../../theme/colors'

type Props = {
  width?: number,
  height?: number,
  color?: Color
}

const GraphBarSolidSvg = ({ width, height, color }: Props) => (
  <svg width={width} height={height} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4.54545 10.9091H0.909091C0.363636 10.9091 0 11.2727 0 11.8182V19.0909C0 19.6364 0.363636 20 0.909091 20H4.54545C5.09091 20 5.45455 19.6364 5.45455 19.0909V11.8182C5.45455 11.2727 5.09091 10.9091 4.54545 10.9091ZM19.0909 7.27273H15.4545C14.9091 7.27273 14.5455 7.63636 14.5455 8.18182V19.0909C14.5455 19.6364 14.9091 20 15.4545 20H19.0909C19.6364 20 20 19.6364 20 19.0909V8.18182C20 7.63636 19.6364 7.27273 19.0909 7.27273ZM11.8182 0H8.18182C7.63636 0 7.27273 0.363636 7.27273 0.909091V19.0909C7.27273 19.6364 7.63636 20 8.18182 20H11.8182C12.3636 20 12.7273 19.6364 12.7273 19.0909V0.909091C12.7273 0.363636 12.3636 0 11.8182 0Z"
      fill={color}
    />
  </svg>
)

GraphBarSolidSvg.defaultProps = {
  width: 20,
  height: 20,
  color: colors.Primary.GreyText
}

export default GraphBarSolidSvg
